import { apiGet } from "./http";
import type { OrgVisureSummary } from "../../api/license-usage-summary";

export function getVisureUsage(signal?: AbortSignal): Promise<OrgVisureSummary> {
  return apiGet("/api/orgs/license/usage", signal);
}
